
import { config } from "../config";
import { generateEventId, sendGaEvent } from "./google";
import { dispatchFbConversionEvent } from "./facebook";

export const dispatchGaAndFacebookEvent = function(gaMetaData, facebookMetaData?, currentPage?) {
    let fbId = '';
    if (config('isFbConversionEnabled') === "true" && facebookMetaData) {
        fbId = generateEventId()
        gaMetaData.fb_event_id = fbId;
    }

    sendGaEvent(gaMetaData);

    if(facebookMetaData) {
        facebookMetaData.event_id = fbId;
        dispatchFbConversionEvent(facebookMetaData, currentPage);
    }
};